
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    setTimeout(function(){ 
      Flits('.flits-profile-menu').prepend('<p class="text">'+ Flits.t("Flits.locals.navigation.profile", "My Profile") +'</p>')
      Flits('.flits-modification-menu').prepend('<p class="text">'+ Flits.t("Flits.locals.navigation.modification", "Modification") +'</p>')
      Flits('.flits-wineclub-menu').prepend('<p class="text">' + Flits.t("Flits.locals.navigation.wine_club", "Wine Club") + '</p>')
    }, 500);
    var settings = event.detail.settings;
    settings.navs[0].title = Flits.t("Flits.locals.navigation.info", "Informations");
    var index = settings.navs.indexOf(settings.navs.find(o => o.url == '#changePassword'));
    [settings.navs[3],settings.navs[index]] =[settings.navs[index],settings.navs[3]];
    index = settings.navs.indexOf(settings.navs.find(o => o.url == '#/subscriptions/list'));
    [settings.navs[4],settings.navs[index]] =[settings.navs[index],settings.navs[4]];
    index = settings.navs.indexOf(settings.navs.find(o => o.title == 'altro'));
    var index1 = settings.navs.indexOf(settings.navs.find(o => o.title == 'indirizzo'));
    [settings.navs[index1],settings.navs[index]] =[settings.navs[index],settings.navs[index1]];
    var obj ={
      title: Flits.t("Flits.locals.navigation.sommelier", "Personal Sommelier"),
      url: "#sommelier",
      target: 0,
      menuClass: null,
      badge: null,
      icon: '<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>',
      isShow: 1,
      loader: { loader_class: null },
      body_html: `<div id="flits_customer_fields"></div>`,
    };
    
    index = settings.navs.indexOf(settings.navs.find(o => o.title == 'altro'));
    settings.navs.splice(index+1,0,obj);

    var listToDelete = ['#address'];
    for (var i = 0; i < settings.navs.length; i++) {
      var obj = settings.navs[i];
      if (listToDelete.indexOf(obj.url) !== -1) {
        settings.navs.splice(i, 1);
        break;
      }
    }
  });
  Flits(document).on('Flits:Navigation:Added',function(event){
    var navs=event.detail.settings.navs;
    var i=event.detail.i;
    var cloneNode=event.detail.menuItemCloneNode;
    if(navs[i].url == '#profile' || navs[i].url=='#order' || navs[i].url =='#changePassword'){
      cloneNode.addClass('flits-profile-submenu');
    }
    else if(navs[i].url == '#/subscriptions/list' || navs[i].url=='https://form.typeform.com/to/lESP4Mf8' || navs[i].url =='https://form.typeform.com/to/lESP4Mf8' || navs[i].url == 'https://form.typeform.com/to/tXJ6nGAW'){
      cloneNode.addClass('flits-modification-submenu');
      if(navs[i].url != '#/subscriptions/list'){
        navs[i].target = 1;
      }
    }
    else if(navs[i].url == "#sommelier" || navs[i].url == "https://sommelierwinebox.com/pages/porta-un-amico"){
      cloneNode.addClass('flits-wineclub-submenu');
    }
    else if(navs[i].url == "/account/logout"){
      cloneNode.addClass('flits-logout-submenu');
    }
    
    if(Flits('.flits-nav-tabs .flits-profile-submenu').length == 3 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-profile-menu").length == 0){
      Flits('.flits-nav-tabs .flits-profile-submenu').wrapAll('<div class="flits-profile-menu menu"></div>');
    }
    else if(Flits('.flits-nav-tabs .flits-modification-submenu').length == 4 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-modification-menu").length == 0){
      Flits('.flits-nav-tabs .flits-modification-submenu').wrapAll('<div class="flits-modification-menu menu"></div>');
    }
    else if(Flits('.flits-nav-tabs .flits-wineclub-submenu').length == 2 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-wineclub-menu").length == 0){
      Flits('.flits-nav-tabs .flits-wineclub-submenu').wrapAll('<div class="flits-wineclub-menu menu"></div>');
    }
    if(Flits('.flits-nav-tabs .flits-logout-submenu').length == 1 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-logout-menu").length == 0){
      Flits('.flits-nav-tabs .flits-logout-submenu').wrapAll('<div class="flits-logout-menu menu"></div>');
    }
  });
  
  // Flits(document).on('Flits:AccountPage:Loaded',function(event){
  //   let customer_note_url = Flits.base_url+'/'+Flits.customer_id + "/get_customer_shopify_data";
  //   Flits.ajax({
  //     method: "get",
  //     url: customer_note_url,
  //     data: {
  //       token: Flits.token,
  //       customer_hash: Flits.customerHash
  //     },
  //   }).done(function(resp){
  //       window.flits_customer_note = resp.customer.note;
  //       if(window.flits_customer_note){
  //       Flits('#flits_tab_sommelier #flits_customer_note').html(window.flits_customer_note);
  //       }
  //     else
  //       {
  //         Flits('#flits_tab_sommelier #flits_customer_note').html(Flits.t("Flits.locals.navigation.no_customer_note","No Customer Notes"));
  //       }
  // })
  // });

  // const sanitizeValueMetafield = (value) => {
  //   if (value.startsWith('["')) {
  //     value = value.slice(2);
  //   }
  //   if (value.endsWith('"]')) {
  //     value = value.slice(0, -2);
  //   }
  //   return value;
  // };
  
  // const replaceQuotesMetafield = (value) => {
  //   return value.replace(/"/g, "'");
  // };


  // Customer mertafield code START

  Flits(document).on('Flits:Navigation:Loaded', function(event){
    let intro_note = window.customerMetafield.intro_note;
    let link_pdf_plan = window.customerMetafield.link_pdf_plan;
    let membership_renewal_date = window.customerMetafield.membership_renewal_date;
    let payment_method = window.customerMetafield.payment_method;
    let intro_seasonal = window.customerMetafield.intro_seasonal;
    let seasonal_spring_name = window.customerMetafield.seasonal_spring_name;
    let seasonal_spring_mix = window.customerMetafield.seasonal_spring_mix;
    let seasonal_spring_ship_date = window.customerMetafield.seasonal_spring_ship_date;
    let seasonal_spring_price = window.customerMetafield.seasonal_spring_price;
    let seasonal_summer_name = window.customerMetafield.seasonal_summer_name;
    let seasonal_summer_mix = window.customerMetafield.seasonal_summer_mix;
    let seasonal_summer_ship_date = window.customerMetafield.seasonal_summer_ship_date;
    let seasonal_summer_price = window.customerMetafield.seasonal_summer_price;
    let seasonal_autumn_name = window.customerMetafield.seasonal_autumn_name;
    let seasonal_autumn_mix = window.customerMetafield.seasonal_autumn_mix;
    let seasonal_autumn_ship_date = window.customerMetafield.seasonal_autumn_ship_date;
    let seasonal_autumn_price = window.customerMetafield.seasonal_autumn_price;
    let seasonal_winter_name = window.customerMetafield.seasonal_winter_name;
    let seasonal_winter_mix = window.customerMetafield.seasonal_winter_mix;
    let seasonal_winter_ship_date = window.customerMetafield.seasonal_winter_ship_date;
    let seasonal_winter_price = window.customerMetafield.seasonal_winter_price;
    let intro_thematic = window.customerMetafield.intro_thematic;
    let thematic_1_name = window.customerMetafield.thematic_1_name;
    let thematic_1_desc = window.customerMetafield.thematic_1_desc;
    let thematic_1_ship_date = window.customerMetafield.thematic_1_ship_date;
    let thematic_1_price = window.customerMetafield.thematic_1_price;
    let thematic_2_name = window.customerMetafield.thematic_2_name;
    let thematic_2_desc = window.customerMetafield.thematic_2_desc;
    let thematic_2_ship_date = window.customerMetafield.thematic_2_ship_date;
    let thematic_2_price = window.customerMetafield.thematic_2_price;
    let thematic_3_name = window.customerMetafield.thematic_3_name;
    let thematic_3_desc = window.customerMetafield.thematic_3_desc;
    let thematic_3_ship_date = window.customerMetafield.thematic_3_ship_date;
    let thematic_3_price = window.customerMetafield.thematic_3_price;
    let thematic_4_name = window.customerMetafield.thematic_4_name;
    let thematic_4_desc = window.customerMetafield.thematic_4_desc;
    let thematic_4_ship_date = window.customerMetafield.thematic_4_ship_date;
    let thematic_4_price = window.customerMetafield.thematic_4_price;
    let text_end_thematic = window.customerMetafield.text_end_thematic;
    let intro_preferences = window.customerMetafield.intro_preferences;
    let customer_experience = window.customerMetafield.customer_experience;
    let customer_red_wines_preference = window.customerMetafield.customer_red_wines_preference;
    let customer_white_wines_preference = window.customerMetafield.customer_white_wines_preference;
    let customer_sparkling_wines_preference = window.customerMetafield.customer_sparkling_wines_preference;
    let customer_grape_variety_preference = window.customerMetafield.customer_grape_variety_preference;
    let customer_natural_wine_preference = window.customerMetafield.customer_natural_wine_preference;
    let customer_special_type_preferences = window.customerMetafield.customer_special_type_preferences;
    let customer_body_preference = window.customerMetafield.customer_body_preference;
    let customer_known_not_known_preference = window.customerMetafield.customer_known_not_known_preference;
    let customer_rare_wines_preference = window.customerMetafield.customer_rare_wines_preference;
    let customer_text_instructions = window.customerMetafield.customer_text_instructions;

    let my_plan = Flits.t('Flits.locals.personal_sommelier.my_plan');
    let membership = Flits.t('Flits.locals.personal_sommelier.membership');
    let payment_type = Flits.t('Flits.locals.personal_sommelier.payment_type');
    let moments_magic = Flits.t('Flits.locals.personal_sommelier.moments_magic');
    let my_preferences = Flits.t('Flits.locals.personal_sommelier.my_preferences');
    let composition = Flits.t('Flits.locals.personal_sommelier.composition');
    let send_date = Flits.t('Flits.locals.personal_sommelier.send_date');
    let price = Flits.t('Flits.locals.personal_sommelier.price');
    let knowledge_flavors = Flits.t('Flits.locals.personal_sommelier.knowledge_flavors');
    let i_feel = Flits.t('Flits.locals.personal_sommelier.i_feel');
    let i_like_them = Flits.t('Flits.locals.personal_sommelier.i_like_them');
    let rossi = Flits.t('Flits.locals.personal_sommelier.rossi');
    let bianchi = Flits.t('Flits.locals.personal_sommelier.bianchi');
    let bollicine = Flits.t('Flits.locals.personal_sommelier.bollicine');
    let wines_lists = Flits.t('Flits.locals.personal_sommelier.wines_lists');
    let natural_wines = Flits.t('Flits.locals.personal_sommelier.natural_wines');
    let love_wines = Flits.t('Flits.locals.personal_sommelier.love_wines');
    let i_prefer = Flits.t('Flits.locals.personal_sommelier.i_prefer');
    let would_try = Flits.t('Flits.locals.personal_sommelier.would_try');
    let fine_wines = Flits.t('Flits.locals.personal_sommelier.fine_wines');
    let empty_section_text = Flits.t('Flits.locals.personal_sommelier.empty_section_text');

    // free_note = sanitizeValueMetafield(free_note);
    // free_note = replaceQuotesMetafield(free_note);

    setTimeout(function(){
      let fieldSectionLast;
      let customer_field_div = Flits("#flits_customer_fields");

      if (intro_note || link_pdf_plan || membership_renewal_date || payment_method || intro_seasonal || seasonal_spring_name || seasonal_spring_mix || seasonal_spring_ship_date || seasonal_spring_price || seasonal_summer_name || seasonal_summer_mix || seasonal_summer_ship_date || seasonal_summer_price || seasonal_autumn_name || seasonal_autumn_mix || seasonal_autumn_ship_date || seasonal_autumn_price || seasonal_winter_name || seasonal_winter_mix || seasonal_winter_ship_date || seasonal_winter_price || intro_thematic || thematic_1_name || thematic_1_desc || thematic_1_ship_date || thematic_1_price || thematic_2_name || thematic_2_desc || thematic_2_ship_date || thematic_2_price || thematic_3_name || thematic_3_desc || thematic_3_ship_date || thematic_3_price || thematic_4_name || thematic_4_desc || thematic_4_ship_date || thematic_4_price || text_end_thematic || intro_preferences || customer_experience || customer_red_wines_preference || customer_white_wines_preference || customer_sparkling_wines_preference || customer_grape_variety_preference || customer_natural_wine_preference || customer_special_type_preferences || customer_body_preference || customer_known_not_known_preference || customer_rare_wines_preference || customer_text_instructions)
      {
        if(intro_note || link_pdf_plan || membership_renewal_date || payment_method){
          var fieldSectionOne = `<div class="main_section first_main_section">`;
          if (intro_note) {fieldSectionOne += `<p class="intro_note field_values">${intro_note}</p>`;}
          if (link_pdf_plan) {fieldSectionOne += `<p>${my_plan}: <span class="link_pdf_plan field_values">${link_pdf_plan}</span></p>`;}
          if (membership_renewal_date) {fieldSectionOne += `<p>${membership}: <span class="membership_renewal_date field_values">${membership_renewal_date}</span></p>`;}
          if (payment_method) {fieldSectionOne += `<p>${payment_type}: <span class="payment_method field_values">${payment_method}</span></p>`;}
          fieldSectionOne += `</div>`;
        }

        if(intro_seasonal || seasonal_spring_name || seasonal_spring_mix || seasonal_spring_ship_date || seasonal_spring_price || seasonal_summer_name || seasonal_summer_mix || seasonal_summer_ship_date || seasonal_summer_price || seasonal_autumn_name || seasonal_autumn_mix || seasonal_autumn_ship_date || seasonal_autumn_price || seasonal_winter_name || seasonal_winter_mix || seasonal_winter_ship_date || seasonal_winter_price || intro_thematic || thematic_1_name || thematic_1_desc || thematic_1_ship_date || thematic_1_price || thematic_2_name || thematic_2_desc || thematic_2_ship_date || thematic_2_price || thematic_3_name || thematic_3_desc || thematic_3_ship_date || thematic_3_price || thematic_4_name || thematic_4_desc || thematic_4_ship_date || thematic_4_price || text_end_thematic)
        {
          var fieldSectionTwo = `<div class="main_section"><p class="section_main_header">${my_plan}</p>`;

          if(intro_seasonal || seasonal_spring_name || seasonal_spring_mix || seasonal_spring_ship_date || seasonal_spring_price || seasonal_summer_name || seasonal_summer_mix || seasonal_summer_ship_date || seasonal_summer_price || seasonal_autumn_name || seasonal_autumn_mix || seasonal_autumn_ship_date || seasonal_autumn_price || seasonal_winter_name || seasonal_winter_mix || seasonal_winter_ship_date || seasonal_winter_price)
          {
            fieldSectionTwo += `<p class="seasonal_head">${moments_magic}</p>`;
            if (intro_seasonal) {fieldSectionTwo += `<p class="intro_seasonal field_values">${intro_seasonal}</p>`;}

            if(seasonal_spring_name || seasonal_spring_mix || seasonal_spring_ship_date || seasonal_spring_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (seasonal_spring_name) {fieldSectionTwo += `<p class="seasonal_spring_name field_values">${seasonal_spring_name}</p>`;}
              if (seasonal_spring_mix) {fieldSectionTwo += `<li class="seasonal_all_values">${composition}: <span class="seasonal_spring_mix field_values">${seasonal_spring_mix}</span></li>`;}
              if (seasonal_spring_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="seasonal_spring_ship_date field_values">${seasonal_spring_ship_date}</span></li>`;}
              if (seasonal_spring_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="seasonal_spring_price field_values">${seasonal_spring_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(seasonal_summer_name || seasonal_summer_mix || seasonal_summer_ship_date || seasonal_summer_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (seasonal_summer_name) {fieldSectionTwo += `<p class="seasonal_summer_name field_values">${seasonal_summer_name}</p>`;}
              if (seasonal_summer_mix) {fieldSectionTwo += `<li class="seasonal_all_values">${composition}: <span class="seasonal_summer_mix field_values">${seasonal_summer_mix}</span></li>`;}
              if (seasonal_summer_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="seasonal_summer_ship_date field_values">${seasonal_summer_ship_date}</span></li>`;}
              if (seasonal_summer_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="seasonal_summer_price field_values">${seasonal_summer_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(seasonal_autumn_name || seasonal_autumn_mix || seasonal_autumn_ship_date || seasonal_autumn_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (seasonal_autumn_name) {fieldSectionTwo += `<p class="seasonal_autumn_name field_values">${seasonal_autumn_name}</p>`;}
              if (seasonal_autumn_mix) {fieldSectionTwo += `<li class="seasonal_all_values">${composition}: <span class="seasonal_autumn_mix field_values">${seasonal_autumn_mix}</span></li>`;}
              if (seasonal_autumn_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="seasonal_autumn_ship_date field_values">${seasonal_autumn_ship_date}</span></li>`;}
              if (seasonal_autumn_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="seasonal_autumn_price field_values">${seasonal_autumn_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(seasonal_winter_name || seasonal_winter_mix || seasonal_winter_ship_date || seasonal_winter_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (seasonal_winter_name) {fieldSectionTwo += `<p class="seasonal_winter_name field_values">${seasonal_winter_name}</p>`;}
              if (seasonal_winter_mix) {fieldSectionTwo += `<li class="seasonal_all_values">${composition}: <span class="seasonal_winter_mix field_values">${seasonal_winter_mix}</span></li>`;}
              if (seasonal_winter_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="seasonal_winter_ship_date field_values">${seasonal_winter_ship_date}</span></li>`;}
              if (seasonal_winter_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="seasonal_winter_price field_values">${seasonal_winter_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }
          }

          if(intro_thematic || thematic_1_name || thematic_1_desc || thematic_1_ship_date || thematic_1_price || thematic_2_name || thematic_2_desc || thematic_2_ship_date || thematic_2_price || thematic_3_name || thematic_3_desc || thematic_3_ship_date || thematic_3_price || thematic_4_name || thematic_4_desc || thematic_4_ship_date || thematic_4_price || text_end_thematic)
          {
            fieldSectionTwo += `<p class="seasonal_head">${knowledge_flavors}</p>`;
            if (intro_thematic) {fieldSectionTwo += `<p class="intro_thematic field_values">${intro_thematic}</p>`;}

            if(thematic_1_name || thematic_1_desc || thematic_1_ship_date || thematic_1_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (thematic_1_name) {fieldSectionTwo += `<p class="thematic_1_name field_values">${thematic_1_name}</p>`;}
              if (thematic_1_desc) {fieldSectionTwo += `<p class="thematic_1_desc field_values">${thematic_1_desc}</p>`;}
              if (thematic_1_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="thematic_1_ship_date field_values">${thematic_1_ship_date}</span></li>`;}
              if (thematic_1_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="thematic_1_price field_values">${thematic_1_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(thematic_2_name || thematic_2_desc || thematic_2_ship_date || thematic_2_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (thematic_2_name) {fieldSectionTwo += `<p class="thematic_2_name field_values">${thematic_2_name}</p>`;}
              if (thematic_2_desc) {fieldSectionTwo += `<p class="thematic_2_desc field_values">${thematic_2_desc}</p>`;}
              if (thematic_2_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="thematic_2_ship_date field_values">${thematic_2_ship_date}</span></li>`;}
              if (thematic_2_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="thematic_2_price field_values">${thematic_2_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(thematic_3_name || thematic_3_desc || thematic_3_ship_date || thematic_3_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (thematic_3_name) {fieldSectionTwo += `<p class="thematic_3_name field_values">${thematic_3_name}</p>`;}
              if (thematic_3_desc) {fieldSectionTwo += `<p class="thematic_3_desc field_values">${thematic_3_desc}</p>`;}
              if (thematic_3_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="thematic_3_ship_date field_values">${thematic_3_ship_date}</span></li>`;}
              if (thematic_3_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="thematic_3_price field_values">${thematic_3_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if(thematic_4_name || thematic_4_desc || thematic_4_ship_date || thematic_4_price){
              fieldSectionTwo += `<div class="seasonal_topics">`
              if (thematic_4_name) {fieldSectionTwo += `<p class="thematic_4_name field_values">${thematic_4_name}</p>`;}
              if (thematic_4_desc) {fieldSectionTwo += `<p class="thematic_4_desc field_values">${thematic_4_desc}</p>`;}
              if (thematic_4_ship_date) {fieldSectionTwo += `<li class="seasonal_all_values">${send_date}: <span class="thematic_4_ship_date field_values">${thematic_4_ship_date}</span></li>`;}
              if (thematic_4_price) {fieldSectionTwo += `<li class="seasonal_all_values">${price}: <span class="thematic_4_price field_values">${thematic_4_price}</span></li>`;}
              fieldSectionTwo += `</div>`;
            }

            if (text_end_thematic) {fieldSectionTwo += `<p class="text_end_thematic field_values">${text_end_thematic}</p>`;}

            fieldSectionTwo += `</div>`;
          }
        }

        if(intro_preferences || customer_experience || customer_red_wines_preference || customer_white_wines_preference || customer_sparkling_wines_preference || customer_grape_variety_preference || customer_natural_wine_preference || customer_special_type_preferences || customer_body_preference || customer_known_not_known_preference || customer_rare_wines_preference)
        {
          var fieldSectionThree = `<div class="main_section third_main_section"><p class="section_main_header">${my_preferences}</p>`;

          if (intro_preferences) {fieldSectionThree += `<p class="intro_preferences field_values">${intro_preferences}</p>`;}
          if (customer_experience) {fieldSectionThree += `<p>${i_feel}: <span class="customer_experience field_values">${customer_experience}</span></p>`;}

          if(customer_red_wines_preference || customer_white_wines_preference || customer_sparkling_wines_preference){
            fieldSectionThree += `<div class="seasonal_topics mi_piacciono_section"><p>${i_like_them}</p>`
            if (customer_red_wines_preference) {fieldSectionThree += `<p class="seasonal_all_values">${rossi}: <span class="customer_red_wines_preference field_values">${customer_red_wines_preference}</span></p>`;}
            if (customer_white_wines_preference) {fieldSectionThree += `<p class="seasonal_all_values">${bianchi}: <span class="customer_white_wines_preference field_values">${customer_white_wines_preference}</span></li>`;}
            if (customer_sparkling_wines_preference) {fieldSectionThree += `<p class="seasonal_all_values">${bollicine}: <span class="customer_sparkling_wines_preference field_values">${customer_sparkling_wines_preference}</span></p>`;}
            fieldSectionThree += `</div>`;
          }

          if (customer_grape_variety_preference) {fieldSectionThree += `<p class="section_three_tabs">${wines_lists}: <span class="customer_grape_variety_preference field_values">${customer_grape_variety_preference}</span></p>`;}
          if (customer_natural_wine_preference) {fieldSectionThree += `<p class="section_three_tabs">${natural_wines}: <span class="customer_natural_wine_preference field_values">${customer_natural_wine_preference}</span></p>`;}
          if (customer_special_type_preferences) {fieldSectionThree += `<p class="section_three_tabs">${love_wines}: <span class="customer_special_type_preferences field_values">${customer_special_type_preferences}</span></p>`;}
          if (customer_body_preference) {fieldSectionThree += `<p class="section_three_tabs">${i_prefer}: <span class="customer_body_preference field_values">${customer_body_preference}</span></p>`;}
          if (customer_known_not_known_preference) {fieldSectionThree += `<p class="section_three_tabs">${would_try}: <span class="customer_known_not_known_preference field_values">${customer_known_not_known_preference}</span></p>`;}
          if (customer_rare_wines_preference) {fieldSectionThree += `<p class="section_three_tabs">${fine_wines}: <span class="customer_rare_wines_preference field_values">${customer_rare_wines_preference}</span></p>`;}

          fieldSectionThree += `</div>`;
        }

        if(customer_text_instructions){
          fieldSectionLast = `<div class="last_main_section"><p class="customer_text_instructions field_values">${customer_text_instructions}</p></div>`;
        }

        if(customer_field_div){
          if(fieldSectionOne)customer_field_div.append(fieldSectionOne);
          if(fieldSectionTwo)customer_field_div.append(fieldSectionTwo);
          if(fieldSectionThree)customer_field_div.append(fieldSectionThree);
          if(fieldSectionLast)customer_field_div.append(fieldSectionLast);
        }
      }
      else{
        let emptySectionDiv = `<div class="empty_section"><p>${empty_section_text}</p></div>`
        customer_field_div.append(emptySectionDiv);
      }
    }, 1000);
  });

  // Customer mertafield code END

}(Flits));
